import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import Store from './Store/store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
 <Provider store={Store}>
    <App />
  </Provider>
);

// If you want to start measuring performan                                                                                                 ce in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
